import React, { useCallback, useEffect, useState } from 'react';
import { MatchesView } from './views/MatchesView';
import { CalendarView } from './views/CalendarView';
import { GroupsView } from './views/GroupsView';
import { TeamsView } from './views/TeamsView';
import { useSelector } from 'react-redux';

const MundialViews = () => {
  const { code } = useSelector(state => state.navigation.currentNode);

  const getComponent = useCallback(
    () => {
      switch (code) {
        case 'mundial2022_partidos':
          return <MatchesView />;
        case 'mundial2022_calendario':
          return <CalendarView />;
        case 'mundial2022_grupos':
          return <GroupsView />;
        case 'mundial2022_equipos':
          return <TeamsView />;

        default:
          return <MatchesView />;
      }
    },
    [code],
  );

  return getComponent();
};

export default MundialViews;
